"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitlistBatchFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var WaitlistBatchFactory = /** @class */ (function (_super) {
    __extends(WaitlistBatchFactory, _super);
    function WaitlistBatchFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    WaitlistBatchFactory.prototype.deploy = function (_depositCurrency, _depositLockupDuration, overrides) {
        return _super.prototype.deploy.call(this, _depositCurrency, _depositLockupDuration, overrides || {});
    };
    WaitlistBatchFactory.prototype.getDeployTransaction = function (_depositCurrency, _depositLockupDuration, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _depositCurrency, _depositLockupDuration, overrides || {});
    };
    WaitlistBatchFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    WaitlistBatchFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    WaitlistBatchFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return WaitlistBatchFactory;
}(contracts_1.ContractFactory));
exports.WaitlistBatchFactory = WaitlistBatchFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_depositCurrency",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_depositLockupDuration",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "AddedToBlacklist",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "batchNumber",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "AppliedToBatch",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_batchNumber",
                type: "uint256",
            },
        ],
        name: "BatchApproved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "batchNumber",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "batchStartTimstamp",
                type: "uint256",
            },
        ],
        name: "BatchTimestampChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "batchNumber",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newTotalSpots",
                type: "uint256",
            },
        ],
        name: "BatchTotalSpotsUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_depositLockupDuration",
                type: "uint256",
            },
        ],
        name: "DepositLockupDurationSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "ModeratorSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "totalSpots",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "batchStartTimestamp",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "depositAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "batchNumber",
                type: "uint256",
            },
        ],
        name: "NewBatchAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "RemovedFromBlacklist",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "TokensReclaimed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "TokensReclaimedBlacklist",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "destination",
                type: "address",
            },
        ],
        name: "TokensTransferred",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_totalSpots",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_batchStartTimestamp",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_depositAmount",
                type: "uint256",
            },
        ],
        name: "addNewBatch",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_user",
                type: "address",
            },
        ],
        name: "addToBlacklist",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_batchNumber",
                type: "uint256",
            },
        ],
        name: "applyToBatch",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_batchNumber",
                type: "uint256",
            },
        ],
        name: "approveBatch",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "batchMapping",
        outputs: [
            {
                internalType: "uint256",
                name: "totalSpots",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "filledSpots",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "batchStartTimestamp",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "depositAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "approvedAt",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "blacklist",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_batchNumber",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_newStartTimestamp",
                type: "uint256",
            },
        ],
        name: "changeBatchStartTimestamp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_batchNumber",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_newSpots",
                type: "uint256",
            },
        ],
        name: "changeBatchTotalSpots",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "currentTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "depositCurrency",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "depositLockupDuration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_user",
                type: "address",
            },
        ],
        name: "getBatchInfoForUser",
        outputs: [
            {
                components: [
                    {
                        internalType: "bool",
                        name: "hasParticipated",
                        type: "bool",
                    },
                    {
                        internalType: "uint256",
                        name: "batchNumber",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "depositAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "depositRetrievalTimestamp",
                        type: "uint256",
                    },
                ],
                internalType: "struct WaitlistBatch.UserBatchInfo",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "getDepositRetrievalTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getTotalNumberOfBatches",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "moderator",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nextBatchNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "reclaimTokens",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_user",
                type: "address",
            },
        ],
        name: "removeFromBlacklist",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_duration",
                type: "uint256",
            },
        ],
        name: "setDepositLockupDuration",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_user",
                type: "address",
            },
        ],
        name: "setModerator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_tokenAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_destination",
                type: "address",
            },
        ],
        name: "transferTokens",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "userBatchMapping",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "userDepositMapping",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
